{
  "Open support, new reply": "Otwórz czat z pomocą techniczną, nowa odpowiedź",
  "Open support": "Otwórz czat z pomocą techniczną",
  "Attachment": "Załącznik",
  "Fin · previous AI assistant": "Fin · poprzedni asystent AI",
  "EventLive support team": "Zespół pomocy technicznej EventLive",
  "{name} · EventLive support": "{name} · pomoc techniczna EventLive",
  "EventLive AI assistant": "Asystent AI EventLive",
  "Could not restore your previous conversation. You can retry by reopening the app.": "Nie udało się przywrócić poprzedniej rozmowy. Aby spróbować ponownie, otwórz aplikację jeszcze raz.",
  "Please choose a smaller image.": "Wybierz mniejszy obraz.",
  "Please choose a JPEG or PNG image.": "Wybierz obraz JPEG lub PNG.",
  "Open {name}": "Otwórz: {name}",
  "We’re here to help": "Chętnie pomożemy",
  "Team review requested · AI can still help": "Przekazano do zespołu · AI nadal może pomóc",
  "Collapse chat": "Zwiń czat",
  "Expand chat": "Rozwiń czat",
  "Close support": "Zamknij czat z pomocą techniczną",
  "Current conversation": "Bieżąca rozmowa",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "Cześć! Zapytaj mnie o wszystko, co dotyczy EventLive: ceny, planowanie transmisji na żywo lub oglądanie wydarzenia.",
  "Have an account? Sign in for help with your events": "Masz konto? Zaloguj się, aby uzyskać pomoc dotyczącą swoich wydarzeń",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "Pytaj o wszystko, co dotyczy transmisji, twoich wydarzeń lub cen. Aby pomóc, mogę korzystać z danych twojego konta i ekranu, na którym jesteś.",
  "Retry message": "Wyślij ponownie",
  "Remove photo": "Usuń zdjęcie",
  "Support message": "Wiadomość do pomocy technicznej",
  "Tell us what you’re trying to do…": "Napisz, co chcesz zrobić…",
  "Attach": "Załącz",
  "Could not open your photos.": "Nie udało się otworzyć zdjęć.",
  "Send": "Wyślij",
  "Close support backdrop": "Zamknij czat z pomocą techniczną (tło)",
  "AI assistant is typing": "Asystent AI pisze",
  "AI assistant": "Asystent AI",
  "Please sign in to contact support.": "Zaloguj się, aby skontaktować się z pomocą techniczną.",
  "Could not reach support. Check your internet connection and try again.": "Nie udało się połączyć z pomocą techniczną. Sprawdź połączenie z internetem i spróbuj ponownie.",
  "Support is temporarily unavailable. Please try again.": "Pomoc techniczna jest chwilowo niedostępna. Spróbuj ponownie.",
  "Could not send your message.": "Nie udało się wysłać wiadomości.",
  "No message sent": "Nie wysłano wiadomości",
  "Demo delivery: screenshot included · {platform}": "Dostarczenie testowe: ze zrzutem ekranu · {platform}",
  "Demo delivery: no screenshot · {platform}": "Dostarczenie testowe: bez zrzutu ekranu · {platform}",
  "EventLive · Widget test": "EventLive · Test widżetu",
  "Synthetic account and replies. No customer data or live API calls.": "Fikcyjne konto i odpowiedzi. Bez danych klientów i bez prawdziwych wywołań API.",
  "Your events": "Twoje wydarzenia",
  "Family celebration": "Uroczystość rodzinna",
  "Published · Recording ready": "Opublikowane · Nagranie gotowe",
  "Demo delivery status": "Stan dostarczenia testowego",
  "{brand} support team": "Zespół pomocy technicznej {brand}",
  "You’re chatting with the {brand} support team": "Rozmawiasz z zespołem pomocy technicznej {brand}",
  "You’re talking with the {brand} AI assistant": "Rozmawiasz z asystentem AI {brand}",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "Zespół {brand} odpowiada tutaj. Jeśli zamkniesz czat, odpowiedź przyjdzie też e-mailem.",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "Cześć! Zapytaj mnie o wszystko, co dotyczy YouthStream: plany i ceny, transmisje meczów twojej drużyny lub oglądanie meczu.",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "Korzystasz z aplikacji? Aby uzyskać pomoc dotyczącą konta, otwórz czat z pomocą techniczną w profilu w aplikacji YouthStream."
}
